<dashboardnav>
    <div class="box green_box"></div>
        <div class="box pink_box"></div>
        <main class="the_main" [@fadeInAnimation]>
    <cradua-search
        [task]="task"
        [pipelineDetail]="pipelineDetail$ | async"
        (searchEmit)="onSearch($event)"
        (getAllEmit)="onGetAll($event)"
        (emitTask)="onTask($event)"
        >
    </cradua-search>
    <div [ngSwitch]="task">
        <ng-template ngSwitchCase="list">
            <cradua-pipeline-list
                [pipelineDetails]="pipelineDetail$ | async"
                [licencestatuss]="licencestatuss$ | async"
                (dispatchView)="onEmitView($event)"
                *ngIf="
                  !(isLoadingPipelinedetails$ | async)        
                ">
            </cradua-pipeline-list>
            <mrsoftapps-epims-reference-spinner
            *ngIf="(isLoadingPipelinedetails$ | async)"
                >
            </mrsoftapps-epims-reference-spinner>
        </ng-template>
        <ng-template ngSwitchCase="create">
            <cradua-pipelinedetails
                [loggedInUser]="loggedInUser"
                [subsubgroups]="subsubgroups$ | async"
                [categorys]="categorys$ | async"
                [functions]="functions$ | async"
                [accountablefunctions]="accountablefunctions$ | async"
                [opllptshistorys]="opllptshistorys$ | async"
                [pipelineassets]="pipelineassets$ | async"
                [assetstatuss]="assetstatuss$ | async"
                [pigibilitys]="pigibilitys$ | async"
                [assetlocations]="assetlocations$ | async"
                [deliverytypes]="deliverytypes$ | async"
                [licencestatuss]="licencestatuss$ | async"
                [uomes]="uomes$ | async"
                [networks]="networks$ | async"
                [ipstatuss]="ipstatuss$ | async"
                [pipelinegrades]="pipelinegrades$ | async"
                [landTitles]="landTitle$ | async"
                [pipelineDetails]="pipelineDetail$ | async"
                [pipelineassetlink2s]="pipelineassetlink2s$ | async"
                [isLoadingPipelineassetlink2s]="isLoadingPipelineassetlink2s$ | async"
                [acountablefunctionlink2s]="acountablefunctionlink2s$ | async"
                [isLoadingAcountablefunctionlink2s]="isLoadingAcountablefunctionlink2s$ | async"
                [pipelinesections]="pipelinesections$ | async"
                [isLoadingPipelinesections]="isLoadingPipelinesections$ | async"
                (emitAssetSave) = "onAssetSubmit($event)"
                (emitFxtSave) = "onFxtSubmit($event)"
                (emitSectionDelete) = "onSectionDelete($event)"
                (emitSectionSave) = "onSectionSubmit($event)"
                (emitFxtDelete) = "onFxtDelete($event)"
                (emitAssetDelete) = "onAssetDelete($event)"
                (onBackEvent) = "onBack()"
                (submitPipelineEvent) = "onSubmit($event)"
                (onNextEvent) = "onNext($event)"
                
                *ngIf="
                !(isLoadingPipelinedetails$ | async) &&
                !(isLoadingAssetstatuss$ | async) &&
                !(isLoadingPigibilitys$ | async) &&
                !(isLoadingAssetlocations$ | async) &&
                !(isLoadingDeliverytypes$ | async) &&
                !(isLoadingUomes$ | async) &&
                !(isLoadingLicencestatuss$ | async) &&
                !(isLoadingNetworks$ | async) &&
                !(isLoadingIpstatuss$ | async) &&
                !(isLoadingPipelinegrades$ | async) &&
                !(isLoadingAccountablefunctions$ | async) &&
                !(isLoadingPipelineassets$ | async) &&
                !(isLoadingFunctions$ | async)"
            >
            </cradua-pipelinedetails>
            <cradua-list-spinner
            *ngIf="(isLoadingPipelinedetails$ | async) ||
            (isLoadingAssetstatuss$ | async) ||
            (isLoadingPigibilitys$ | async) ||
            (isLoadingAssetlocations$ | async) ||
            (isLoadingDeliverytypes$ | async) ||
            (isLoadingUomes$ | async) ||
            (isLoadingLicencestatuss$ | async) ||
            (isLoadingNetworks$ | async) ||
            (isLoadingIpstatuss$ | async) ||
            (isLoadingPipelinegrades$ | async) ||
            (isLoadingAccountablefunctions$ | async) ||
            (isLoadingPipelineassets$ | async) ||
            (isLoadingFunctions$ | async)"
        >
        </cradua-list-spinner>
        </ng-template>

</div>
</main>

</dashboardnav>
